import { render, staticRenderFns } from "./LubricantsInput.vue?vue&type=template&id=afff0eaa&scoped=true&"
import script from "./LubricantsInput.vue?vue&type=script&lang=js&"
export * from "./LubricantsInput.vue?vue&type=script&lang=js&"
import style0 from "./LubricantsInput.vue?vue&type=style&index=0&id=afff0eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afff0eaa",
  null
  
)

export default component.exports